import { Button } from 'component/Button'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { CardInput } from 'page/catalog/UserModal/step/CardInput'
import { NameInput } from 'page/catalog/UserModal/step/NameInput'
import { PhoneInput } from 'page/catalog/UserModal/step/PhoneInput'
import { userModal } from 'page/catalog/UserModal/store/UserModalStore'
import { opt } from 'store/opt'

export const CreateStep = observer(() => {
  const demo = useDemo()
  const { access } = demo.data.widget
  const store = userModal.it
  const { canCreate } = store
  const disabled = !canCreate || !access

  const onRef = useLatestCallback((root: HTMLDivElement | null) => {
    if (!root) return
    const focus = root.querySelector('input')
    focus?.focus()
  })

  const onCreate = useLatestCallback(async () => {
    if (access) await store.create(access)
  })

  return <Vertical ref={onRef} gap={16}>
    <PhoneInput />
    <NameInput />
    {opt.by_card ? undefined : <CardInput />}
    <Button gap={8} height={48} primary disabled={disabled} action={onCreate}>
      <Typo>{i18n('Create')}</Typo>
    </Button>
  </Vertical>
})
